import { render, staticRenderFns } from "./CounselorWelcome.vue?vue&type=template&id=0d84a375&scoped=true&"
import script from "./CounselorWelcome.vue?vue&type=script&lang=js&"
export * from "./CounselorWelcome.vue?vue&type=script&lang=js&"
import style0 from "./CounselorWelcome.vue?vue&type=style&index=0&id=0d84a375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84a375",
  null
  
)

export default component.exports